module.exports = __webpack_public_path__ + "img/email.77c83e33.svg";